<template>
  <div class="product-grid">
    <div class="product-grid-container__counter">
      <!-- Сейчас всегда показывается N из N потому что для фильтра пагинации нет. -->
      Показано {{ currentItemsNumber || products.length }} из {{ totalItems || products.length }}
    </div>

    <div class="product-grid__items">
      <div
        v-for="product in products"
        :key="product.id"
        :class="[
          'product-grid__item',
          'product-grid__item--sm-' + colSm,
          'product-grid__item--md-' + colMd,
          'product-grid__item--xl-' + colXl,
        ]"
      >
        <article class="product-item">
          <a :href="product.url">
            <div class="product-item__image-overlay" />
            <div class="product-item__image">
              <span v-if="product.isNew" class="product-item__badge uk-badge uk-badge-new">Новинка</span>
              <img
                :src="product.imageUrl"
                :srcset="product.imageSrcset"
                sizes="(max-width: 639px) 50vw, (max-width: 1199px) 33vw, 236px"
                :width="product.imageWidth"
                :height="product.imageHeight"
                :alt="product.name"
                loading="lazy"
              />
            </div>

            <div class="product-item__desc">
              <div class="product-item__price money">
                <span>
                  {{ fPrice(product.price) }} ₽
                </span>
                <span v-if="product.oldPrice !== null" class="crossed">
                  {{ fPrice(product.oldPrice) }} ₽
                </span>
              </div>

              <div class="product-item__name">
                {{ product.name }}
              </div>
            </div>
          </a>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import formatPrice from '../../utilities/format-price';

export default {
  name: 'ProductGrid',
  props: {
    colMd:  { type: Number, default: 4},
    colSm:  { type: Number, default: 6},
    colXl:  { type: Number, default: 3},
    currentItemsNumber: { type: Number, default: null},
    products: {
      type: Array,
      default: () => {
        return [];
      }
    },
    totalItems: { type: Number, default: null},
  },
  methods: {
    fPrice: formatPrice,
  },
};

</script>
